import * as React from 'react';
import * as NotificationSystem from 'react-notification-system';

interface ContextShape {
  notify?: (message: NotificationSystem.Notification) => any;
}

export const CONTEXT = React.createContext<ContextShape>({ notify: undefined });
